module.exports = __webpack_public_path__ + "static/media/moon-cloudy.89ef778b.svg";